export enum STATE {
	DEFAULT = 'default',
	PROCESSING = 'processing',
	COMPLETED = 'completed',
}
